<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <navigation-type-view
          :view-type="viewType"
          @on-select-view="onSelectView"
        />
      </div>
      <div class="col-md-6 d-flex">
        <custom-drop-down
          class="flex-grow-1"
          fieldkey="id"
          fieldname="name"
          :options="[]"
          placeholder="Tipo de Servicio"
        />
        <custom-drop-down
          class="flex-grow-1 ml-3"
          fieldkey="id"
          fieldname="name"
          :options="[]"
          placeholder="Servicio"
        />
      </div>
    </div>
    <div v-if="currentDate" class="row mt-4">
      <div class="col-md-12">
        <navigation-period
          v-if="viewType == 1"
          :current-period="currentDate"
          :initial-period="currentPeriod"
          @on-select-period="onSelectPeriodHandler"
        />
      </div>
    </div>
    <div v-if="viewType != 1">
      <div class="calendar-compact-selector">
        <div class="calendar-compact-selector__action" @click="moveBack">
          <em class="fa fa-chevron-left" />
        </div>
        <div class="calendar-compact-selector__day">
          <span class="color-black font-weight-bold font-16">
            {{ dayText }}
          </span>
        </div>
        <div class="calendar-compact-selector__action" @click="moveForward">
          <em class="fa fa-chevron-right" />
        </div>
      </div>
    </div>
    <hr />
  </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import 'moment/locale/es-do';
import { CustomDropDown } from '@/components/common';
import NavigationTypeView from './NavigationTypeView';
import NavigationPeriod from './NavigationPeriod';

const FULL_DAY_FORMAT = ' LL';
const VIEW_TYPES = {
  MONTH: 1,
  WEEK: 2,
  DAY: 3,
};

export default {
  name: 'SpaceNavigator',
  components: {
    CustomDropDown,
    NavigationTypeView,
    NavigationPeriod,
  },
  props: {
    currentPeriod: {
      type: Date,
      default: () => new Date(),
    },
  },
  data: () => ({
    currentDate: new Date(),
    currentDateEnd: moment(new Date())
      .add(7, 'days')
      .toDate(),
    viewType: VIEW_TYPES.MONTH,
  }),
  computed: {
    dayText() {
      if (this.viewType == VIEW_TYPES.DAY) {
        return `${this.todayText} ${_.capitalize(
          moment(this.currentDate).format(FULL_DAY_FORMAT)
        )}`;
      } else {
        return `${moment(this.currentDate).format('DD')} al ${moment(
          this.currentDateEnd
        ).format('DD')} de ${moment(this.currentDate).format(
          'MMMM'
        )} de ${moment(this.currentDateEnd).format('YYYY')}`;
      }
    },
    todayText() {
      return moment().isSame(this.currentDate, 'day') ? 'Hoy, ' : '';
    },
    getCurrentDatePeriod() {
      return moment(this.currentDate)
        .add(-1, 'year')
        .toDate();
    },
  },
  methods: {
    moveBack() {
      if (this.viewType == VIEW_TYPES.DAY) {
        this.currentDate = moment(this.currentDate)
          .add(-1, 'days')
          .toDate();
      } else {
        this.currentDateEnd = this.currentDate;
        this.currentDate = moment(this.currentDate)
          .add(-7, 'days')
          .toDate();
      }
      this.$emit('on-navigation-change', {
        startDate: this.currentDate,
        endDate: this.currentDateEnd,
      });
    },
    moveForward() {
      if (this.viewType == VIEW_TYPES.DAY) {
        this.currentDate = moment(this.currentDate)
          .add(1, 'days')
          .toDate();
      } else {
        this.currentDate = this.currentDateEnd;
        this.currentDateEnd = moment(this.currentDate)
          .add(7, 'days')
          .toDate();
      }
      this.$emit('on-navigation-change', {
        startDate: this.currentDate,
        endDate: this.currentDateEnd,
      });
    },
    onSelectView(viewType) {
      if (viewType) {
        this.viewType = viewType;
        this.$emit('on-select-view', viewType);
      }
    },
    onSelectPeriodHandler(value) {
      this.currentDate = value;
      this.currentDateEnd = moment(value)
        .add(7, 'days')
        .toDate();
      this.$emit('on-select-period', value);
    },
  },
};
</script>

<style scoped lang="scss">
.calendar-compact-selector {
  display: flex;
  flex-direction: row;
  &__day {
    display: flex;
    background: #d9e5df;
    flex: 1;
    border-radius: 5px;
    margin-left: 10px;
    margin-right: 10px;
    justify-content: center;
    align-items: center;
  }
  &__action {
    cursor: pointer;
    background: #d9e5df;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 37px;
    height: 37px;
    border-radius: 5px;
    em {
      color: #000000;
    }
  }
}
</style>
